/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const TrianglesMiniSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.90988 5.75C4.74682 5.74994 4.58676 5.71269 4.44646 5.64216C4.30615 5.57162 4.19073 5.47039 4.11228 5.34904C4.03383 5.22769 3.99521 5.09067 4.00047 4.95232C4.00574 4.81397 4.05468 4.67936 4.14219 4.56255L6.7317 1.10788C6.81392 0.998207 6.9274 0.907911 7.06165 0.845354C7.19589 0.782797 7.34656 0.75 7.4997 0.75C7.65284 0.75 7.8035 0.782797 7.93775 0.845354C8.07199 0.907911 8.18547 0.998207 8.26769 1.10788L10.8578 4.56255C10.9453 4.67939 10.9943 4.81405 10.9995 4.95245C11.0048 5.09085 10.9661 5.2279 10.8876 5.34926C10.809 5.47063 10.6935 5.57185 10.5532 5.64235C10.4128 5.71285 10.2526 5.75003 10.0895 5.75H4.90988Z"
          fill="currentColor"
        />
        <path
          d="M10.0901 9.25C10.2532 9.25006 10.4132 9.28731 10.5535 9.35784C10.6939 9.42838 10.8093 9.52961 10.8877 9.65096C10.9662 9.77231 11.0048 9.90933 10.9995 10.0477C10.9943 10.186 10.9453 10.3206 10.8578 10.4374L8.2683 13.8921C8.18608 14.0018 8.0726 14.0921 7.93835 14.1546C7.80411 14.2172 7.65344 14.25 7.5003 14.25C7.34716 14.25 7.1965 14.2172 7.06225 14.1546C6.92801 14.0921 6.81453 14.0018 6.73231 13.8921L4.14219 10.4374C4.05465 10.3206 4.00571 10.1859 4.00047 10.0476C3.99523 9.90915 4.0339 9.7721 4.11243 9.65074C4.19095 9.52937 4.30645 9.42815 4.44685 9.35765C4.58724 9.28715 4.74737 9.24997 4.91049 9.25H10.0901Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}

export default TrianglesMiniSvg
